var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTallyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "12px",
    viewBox: "0 0 26 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4844EC69-CA01-460C-8C0B-F032F654CDA6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-history-view",
    transform: "translate(-546, -707)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(500, 657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy-2",
    transform: "translate(36, 35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sock-count-icon",
    transform: "translate(10.442, 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(4.558, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 2,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 5,
    y: 0,
    width: 2,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 10,
    y: 0,
    width: 2,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 15,
    y: 0,
    width: 2,
    height: 12,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    transform: "translate(12.558, 6) rotate(70) translate(-12.558, -6)",
    x: 11.5580242,
    y: -7,
    width: 2,
    height: 26,
    rx: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTallyIcon);
export default __webpack_public_path__ + "static/media/tally-icon.262da40b569dd596e8040d443a1ff7e6.svg";
export { ForwardRef as ReactComponent };